import { IField } from '../components/Field/Field';
import { PlayerEnum } from '../components/Player/constants';
import { getPlayerColor } from './playerColor';
import theme from '../theme/default';

export const getFieldColor = (owner: IField['owner']): string => {
  switch (owner) {
    case PlayerEnum.ONE:
    case PlayerEnum.TWO:
    case PlayerEnum.THREE:
    case PlayerEnum.FOUR:
      return getPlayerColor(owner);
    case 'community':
      return theme.field.background;
    default:
      console.error('COULD NOT MATCH OWNER TO COLOR IN getFieldColor');
      return 'black';
  }
};
